<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <form autocomplete="off" method="post" @submit.prevent="addPayment">
      <div class="row">
        <CustomSelectBox
          :className="'col-md-12'"
          :id="'reservationScheduleToken'"
          :value="paymentData.reservationScheduleToken"
          :options="reservationScheduleTokenOptions"
          v-on:changeValue="paymentData.reservationScheduleToken = $event"
          :title="$t('payments.reservationScheduleName')"
          :imgName="'work-schedule.svg'"
        />
        <CustomSelectBox
          :className="'col-md-6'"
          :id="'methodPaidToken'"
          :value="paymentData.methodPaidToken"
          :options="methodPaidTokenOptions"
          v-on:changeValue="paymentData.methodPaidToken = $event"
          :title="$t('methodPaidSelect')"
          :imgName="'method-paids.svg'"
        />
        <CustomInputFloat
          :className="'col-md-6'"
          :id="'methodPaidValue'"
          :value="paymentData.methodPaidValue"
          v-on:changeValue="paymentData.methodPaidValue = $event"
          :title="$t('payments.methodPaidValue')"
          :imgName="'money.svg'"
        />

        <CustomInputFloat
          :className="'col-md-6'"
          :id="'pointsValue'"
          :value="paymentData.pointsValue"
          v-on:changeValue="paymentData.pointsValue = $event"
          :title="$t('reservations.pointsValue')"
          :imgName="'points.svg'"
        />
        <CustomInputFloat
          :className="'col-md-6'"
          :id="'onePointEqualNumberMoneyValue'"
          :value="paymentData.onePointEqualNumberMoneyValue"
          v-on:changeValue="paymentData.onePointEqualNumberMoneyValue = $event"
          :title="$t('reservations.onePointEqualValue')"
          :imgName="'money.svg'"
        />

        <TextArea
          :className="'col-md-12'"
          :id="'payNote'"
          :value="paymentData.payNote"
          v-on:changeValue="paymentData.payNote = $event"
          :title="$t('notes')"
          :imgName="'notes.svg'"
        />
      </div>

      <div class="form-footer">
        <button name="submit" type="submit" class="btn btn-submit">
          {{ submitName }}
        </button>
        <router-link :to="{ name: 'Payments' }" class="btn btn-cancel">
          {{ $t("cancel") }}
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import CustomInputFloat from "@/components/general/CustomInputFloat.vue";
import CustomSelectBox from "@/components/general/CustomSelectBox.vue";
import TextArea from "@/components/general/TextArea.vue";
import PaymentMethode from "@/models/settings/settingsOther/paymentMethodes/PaymentMethode";
import createToastMixin from "@/utils/create-toast-mixin";
import axios from "axios";

export default {
  name: "PaymentForm",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    CustomInputFloat,
    CustomSelectBox,
    TextArea,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      methodPaidData: new PaymentMethode(),
      methodPaidTokenOptions: [],
      reservationScheduleTokenOptions: [],
    };
  },
  methods: {
    async addPayment() {
      this.$emit("addPayment", this.paymentData);
    },
    async getDialogOfPaymentMethodes() {
      this.isLoading = true;
      this.methodPaidTokenOptions = [];
      this.methodPaidTokenOptions.push({
        value: "",
        text: this.$t("methodPaidSelect"),
      });
      try {
        let response = await this.methodPaidData.getDialogOfPaymentMethodes(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.methodPaidTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("updateUserData", null);
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfReservationSchedules() {
      this.isLoading = true;
      this.reservationScheduleTokenOptions = [];
      this.reservationScheduleTokenOptions.push({
        value: "",
        text: this.$t("payments.reservationScheduleName"),
      });
      try {
        let response = await axios.get(
          `/ReservationsSchedules/GetDialogOfReservationsSchedules?language=${this.language}&userAuthorizeToken=${this.userAuthorizeToken}`
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.reservationScheduleTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("updateUserData", null);
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  props: ["paymentData", "submitName"],
  computed: {},
  async created() {
    this.getDialogOfReservationSchedules();
    this.getDialogOfPaymentMethodes();
  },
};
</script>

<style lang="scss"></style>
